import { state } from '__common/store';
import { checkSelfIntersection, newRoofIntersectionWarning, advanceRoofSelectingAlert } from '__editor/components/roofsSelector/components/roofsSelectorAdvanceRoofSelecting/roofsSelectorAdvanceRoofSelecting';
import { advanceRoofSelectingLineModel, advanceRoofSelectingModel } from '__editor/googleMapsRoofsSelector/models/advanceRoofSelecting';

export function deployAdvanceSelecting({ dblClick, onClear, selfIntersectionWarning, overlapingWarning, onDeploy, overLapCheck }: {
  dblClick?: boolean,
  onClear: Function,
  selfIntersectionWarning?: string,
  overlapingWarning?: string,
  onDeploy: (cords: any[]) => void,
  overLapCheck?: (coords: any[]) => boolean,
}) {
  const { advanceRoofSelecting: { roofPoints } } = state();
  onClear();

  if (dblClick) {
    roofPoints.splice(-1, 1);
  }

  // filter out duplicate pts
  const newRoofPoints = [];
  roofPoints.forEach(pt => {
    if (!newRoofPoints.find(p => p.x === pt.x && p.y === pt.y)) {
      newRoofPoints.push(pt);
    }
  });

  if (selfIntersectionWarning && selfIntersectionWarning.length && checkSelfIntersection(newRoofPoints)) {
    newRoofIntersectionWarning(selfIntersectionWarning);
    return;
  }

  // A roof is a polygon. Two points are a line; overlap-checking them throws,
  // and saving them would store a roof that cannot close.
  if (newRoofPoints.length > 2 && overLapCheck && overlapingWarning && overlapingWarning.length && overLapCheck(newRoofPoints)) {
    advanceRoofSelectingAlert(overlapingWarning);
    return;
  }

  if (newRoofPoints.length > 2) {
    onDeploy(newRoofPoints);
  }
}

export function getAdvanceRoofSelectingModel(scale: number) {
  const { advanceRoofSelecting: { roofPoints, lastPoint } } = state();

  // Pointer-move hover calls this before the first vertex exists. An empty
  // outline makes the last index -1, so reading .x throws.
  if (!roofPoints || !roofPoints.length || !lastPoint) {
    return;
  }

  const latLngPoints = roofPoints.slice(0);
  const lastRoofPoint = roofPoints[roofPoints.length - 1];
  if (!lastRoofPoint) {
    return;
  }

  if (roofPoints.length === 1 || lastRoofPoint.x !== lastPoint.x && lastRoofPoint.y !== lastPoint.y) {
    latLngPoints.push(lastPoint);
  }
  
  if (latLngPoints.length === 2) {
    return advanceRoofSelectingLineModel(latLngPoints, scale);
  }
  if (latLngPoints.length > 2) {
    return advanceRoofSelectingModel(latLngPoints, scale);
  }
}
